define('viewModels/privileged/qm/SearchArchivedResultsView',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'jquery',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/facetedSearch/InteractionsSearchFacets',
    'viewModels/privileged/qm/InteractionsListView',
    'services/qm/interactionsListFilterService',
    'services/loggingService'
], function (ko,
             _,
             moment,
             $,
             ViewModel,
             InteractionsSearchFacets,
             InteractionsListView,
             interactionsListFilterService,
             loggingService
    ) {
    'use strict';

    var SearchArchivedResultsView = ViewModel.extend(function () {
        var self = this;

        self.conversationSummary = ko.observable();
        self.conversationQuery = ko.observable();
        self.loading = ko.observable(false);

        var searchFiltersList = ko.observableArray();

        var opts = { preGatherLists: true, tableNamespace: 'INTERACTION_SEARCH_RESULTS_LIST'};
        self.interactionsListView = self.subView(InteractionsListView, searchFiltersList, true, opts);
        self.interactionFacets = self.subView(InteractionsSearchFacets, searchFiltersList);

        // Get the last used search filter
        var filterKey = interactionsListFilterService.ARCHIVED_SEARCH_RESULTS_KEY;
        interactionsListFilterService.getFilters(filterKey)
        .then(function (lastSearchFilters) {
            if(lastSearchFilters.length !== 0){
                self.interactionFacets.createSavedFilterTemplates(lastSearchFilters);
            }
            searchFiltersList(ko.toJS(lastSearchFilters));
        })
        .catch(function (error) {
            searchFiltersList([]);
            loggingService.error("Failed to retrieve the user's last search filter setting", error);
        })
        .finally(function () {
            // Update the search results
            self.interactionsListView.isSettingUp(false);
        });

        self.subscribe(searchFiltersList, function (newValue) {
            interactionsListFilterService.setFilters(filterKey, newValue);
        });
    });
    return SearchArchivedResultsView;
});

